
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


// All the sliders on the site
jQuery(function($){


  $('.slider').each(function(index, element) {
    let slidesPerView = $(this).find('.swiper-container').data('slides');
    let isSliderMobile = $(this).data('slider-mobile');
    let autoplay = $(this).data('slider-autoplay');
    let autoheight = $(this).data('slider-autoheight');
    
    // Initialize Swiper conditionally
    const initializeSlider = () => {
        const slider = new Swiper($(this).find('.swiper-container')[0], {
            spaceBetween: 24,
            autoHeight: autoheight && window.innerWidth < 768 ? autoheight : false,
            lazy: true, 
            loop: false,
            speed: 300, 
            autoplay: autoplay
              ? {
                    delay: 2000, 
                    disableOnInteraction: false, 
                }
              : false, 
            navigation: {
                nextEl: $(this).find('.slider__next').toArray(), 
                prevEl: $(this).find('.slider__prev').toArray(), 
            },
            pagination: {
                el: $(this).find('.slider__pagination').toArray(),
                clickable: true,
            },
            watchSlidesProgress: true, 
            slideToClickedSlide: true, 
            breakpoints: {
                768: {
                    slidesPerView: slidesPerView || 3, 
                },
                767: {
                    slidesPerView: 1, 
                }
            },
            on: {
                init: function () {   
                    updateNavigationState(this, element);
                },
                slideChange: function () {
                    updateNavigationState(this, element);
                },
                reachBeginning: function () {
                    updateNavigationState(this, element);
                },
                reachEnd: function () {
                    updateNavigationState(this, element);
                }
            }
        });

        function updateNavigationState(sliderInstance, element) {
            const $prevButton = $(element).find('.slider__prev');
            const $nextButton = $(element).find('.slider__next');

            if (sliderInstance.isBeginning) {
                $prevButton.addClass('disabled');
            } else {
                $prevButton.removeClass('disabled');
            }

            if (sliderInstance.isEnd) {
                $nextButton.addClass('disabled');
            } else {
                $nextButton.removeClass('disabled');
            }
        }
    };

    // Check slider-mobile condition and viewport width
    if (isSliderMobile) {
        if (window.innerWidth < 767) {
            initializeSlider();
        }
    } else {
        initializeSlider();
    }
  });
});


